export default "/images/c54db2106c18d3fb9d467cf25acc4e2a.avif";